"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
var _toConsumableArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.string.starts-with");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.array.find-index");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.array.sort");
var _popupConfig = require("@/api/popup/popupConfig.js");
var _decorateConfig = require("@/api/decorate/decorateConfig.js");
var _decorateConfigItem = require("@/api/decorate/decorateConfigItem.js");
var _memberManagement = require("@/api/member/memberManagement.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'PayFinish',
  props: {
    title: {
      type: String,
      default: '功能配置'
    },
    pageKey: {
      type: String,
      default: ''
    },
    moduleKey: {
      type: String,
      default: ''
    },
    xcxType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      imagePrefix: '',
      id: null,
      loading: false,
      tableData: [],
      selectedItems: [],
      // 用于预览功能的选中项
      dialogVisible: false,
      dialogTitle: '',
      previewVisible: false,
      previewImageUrl: '',
      form: {
        id: null,
        title: '',
        imageUrl: '',
        redirectUrl: '',
        recommendContentParam: '',
        startTime: null,
        endTime: null
      },
      enable: false,
      sort: 0,
      timeRange: [],
      rules: {
        name: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }],
        imageUrl: [{
          required: true,
          message: '请上传图片',
          trigger: 'change'
        }]
      },
      pageList: [],
      // 页面列表数据
      searchName: '',
      // 搜索名称
      originalTableData: [],
      // 原始表格数据
      currentPage: 1,
      pageSize: 10,
      total: 0
    };
  },
  created: function created() {
    // 获取图片前缀
    this.getImagePrefix();
    this.getPageList();
    // 页面加载时获取已保存的配置
    this.loadConfig();
  },
  methods: (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
    // 新增配置
    handleAdd: function handleAdd() {
      this.dialogTitle = '新增配置';
      this.form = {
        imageUrl: '',
        redirectUrl: '',
        recommendContentParam: '',
        startTime: null,
        endTime: null
      };
      this.timeRange = [];
      this.sort = 0;
      this.enable = false;
      this.dialogVisible = true;
    },
    // 编辑配置
    handleEdit: function handleEdit(row) {
      this.dialogTitle = '编辑配置';
      this.form = {
        id: row.id,
        title: row.title,
        imageUrl: row.imageUrl,
        redirectUrl: row.redirectUrl,
        recommendContentParam: row.recommendContentParam || '',
        startTime: row.startTime,
        endTime: row.endTime,
        sort: row.sort
      };
      this.sort = row.sort || 0;
      this.enable = row.enable !== undefined ? row.enable : false;
      this.timeRange = [row.startTime, row.endTime];
      this.dialogVisible = true;
    },
    // 删除配置项
    handleDelete: function () {
      var _handleDelete = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(row) {
        var _this = this;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.$confirm('此操作将永久删除该配置, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var response, _t;
                return regeneratorRuntime.wrap(function (_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _context.prev = 0;
                      if (!(row.id && row.id > 0)) {
                        _context.next = 2;
                        break;
                      }
                      _context.next = 1;
                      return (0, _decorateConfigItem.deleteConfigItem)(row.id);
                    case 1:
                      response = _context.sent;
                      if (!(response.code !== 200)) {
                        _context.next = 2;
                        break;
                      }
                      throw new Error(response.message || '删除失败');
                    case 2:
                      // 清空前端数据
                      _this.tableData = [];
                      _this.form = {
                        imageUrl: '',
                        redirectUrl: '',
                        startTime: null,
                        endTime: null
                      };
                      _this.$message.success('删除成功');
                      // 重新加载配置以确保数据一致性
                      _context.next = 3;
                      return _this.loadConfig();
                    case 3:
                      _context.next = 5;
                      break;
                    case 4:
                      _context.prev = 4;
                      _t = _context["catch"](0);
                      console.error('删除失败:', _t);
                      _this.$message.error('删除失败: ' + (_t.message || '未知错误'));
                    case 5:
                    case "end":
                      return _context.stop();
                  }
                }, _callee, null, [[0, 4]]);
              }))).catch(function () {
                // 用户取消删除
                _this.$message.info('已取消删除');
              });
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function handleDelete(_x) {
        return _handleDelete.apply(this, arguments);
      }
      return handleDelete;
    }(),
    // 切换启用/禁用状态
    handleToggleEnable: function () {
      var _handleToggleEnable = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(row) {
        var updateData, saveData, response, index, _t2;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              // 创建更新数据对象
              updateData = {
                imageUrl: row.imageUrl,
                redirectUrl: row.redirectUrl,
                recommendContentParam: row.recommendContentParam || '',
                startTime: row.startTime,
                endTime: row.endTime
              }; // 如果有id，说明是已有记录，需要调用后端接口更新
              if (!(row.id && row.id > 0)) {
                _context3.next = 5;
                break;
              }
              // 构造保存数据
              saveData = {
                id: row.id,
                title: row.title,
                pageCode: this.pageKey,
                optionCode: this.moduleKey,
                sort: row.sort,
                enable: row.enable,
                // 使用最新的启用状态
                extra: JSON.stringify(updateData)
              }; // 调用后端接口保存配置
              _context3.next = 1;
              return (0, _decorateConfigItem.saveConfigItem)(saveData);
            case 1:
              response = _context3.sent;
              if (!(response.code === 200)) {
                _context3.next = 3;
                break;
              }
              this.$message.success('操作成功');
              _context3.next = 2;
              return this.loadConfig();
            case 2:
              _context3.next = 5;
              break;
            case 3:
              _context3.next = 4;
              return this.loadConfig();
            case 4:
              this.$message.error(response.message || '操作失败!');
            case 5:
              _context3.next = 7;
              break;
            case 6:
              _context3.prev = 6;
              _t2 = _context3["catch"](0);
              console.error('切换失败:', _t2);
              // 如果发生错误，恢复原来的状态
              index = this.tableData.findIndex(function (item) {
                return item.id === row.id;
              });
              if (index > -1) {
                this.tableData[index].enable = !row.enable;
              }
              this.$message.error('切换失败: ' + (_t2.message || '未知错误'));
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 6]]);
      }));
      function handleToggleEnable(_x2) {
        return _handleToggleEnable.apply(this, arguments);
      }
      return handleToggleEnable;
    }(),
    // 处理时间范围变化
    handleTimeRangeChange: function handleTimeRangeChange(value) {
      if (value && value.length === 2) {
        this.form.startTime = value[0];
        this.form.endTime = value[1];
      } else {
        this.form.startTime = null;
        this.form.endTime = null;
      }
    },
    // 处理排序输入框值变化
    handleFormSortChange: function handleFormSortChange(value) {
      this.sort = value;
    },
    // 提交表单
    submitForm: function submitForm() {
      var _this2 = this;
      this.$refs.form.validate(/*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(valid) {
          return regeneratorRuntime.wrap(function (_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                if (!valid) {
                  _context4.next = 1;
                  break;
                }
                // 确保form对象包含enable字段，默认为启用状态
                if (_this2.enable === undefined) {
                  _this2.enable = false;
                }

                // 清空tableData并添加当前表单数据
                _this2.tableData = [_objectSpread({}, _this2.form)];
                _this2.dialogVisible = false;
                _this2.$message.success('操作成功');
                // 保存数据
                _context4.next = 1;
                return _this2.handleSave();
              case 1:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        }));
        return function (_x3) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    // 保存配置
    handleSave: function () {
      var _handleSave = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _loading, extraData, saveData, response, _t3;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              // 显示保存loading状态
              _loading = this.$loading({
                lock: true,
                text: '保存中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              extraData = {
                imageUrl: this.form.imageUrl,
                redirectUrl: this.form.redirectUrl,
                recommendContentParam: this.form.recommendContentParam,
                startTime: this.form.startTime,
                endTime: this.form.endTime
              }; // 构造保存数据，只需要保存当前表单数据，而不是整个tableData数组
              saveData = {
                title: this.form.title,
                pageCode: this.pageKey,
                optionCode: this.moduleKey,
                sort: this.sort,
                enable: this.enable !== undefined ? this.enable : false,
                // 包含启用状态
                extra: JSON.stringify(extraData) // 只保存当前表单对象
              }; // 如果当前表单有id，则是更新操作
              if (this.form.id) {
                saveData.id = this.form.id;
              }

              // 调用后端接口保存配置
              _context5.next = 1;
              return (0, _decorateConfigItem.saveConfigItem)(saveData);
            case 1:
              response = _context5.sent;
              // 关闭loading
              _loading.close();
              if (!(response.code === 200)) {
                _context5.next = 3;
                break;
              }
              this.$message.success('配置保存成功');
              // 保存成功后更新ID
              if (response.data && response.data.id) {
                this.id = response.data.id;
                // 更新form中的id
                this.form.id = response.data.id;
              }
              // 保存成功后重新加载配置
              _context5.next = 2;
              return this.loadConfig();
            case 2:
              _context5.next = 4;
              break;
            case 3:
              this.$message.error(response.message || '保存失败!');
            case 4:
              _context5.next = 6;
              break;
            case 5:
              _context5.prev = 5;
              _t3 = _context5["catch"](0);
              // 关闭loading
              if (loading) {
                loading.close();
              }
              console.error('保存失败:', _t3);
              this.$message.error('保存失败: ' + (_t3.message || '未知错误'));
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 5]]);
      }));
      function handleSave() {
        return _handleSave.apply(this, arguments);
      }
      return handleSave;
    }(),
    // 对话框关闭回调
    handleDialogClose: function handleDialogClose() {
      this.$refs.form.resetFields();
      this.timeRange = [];
    },
    // 确认保存
    confirmSave: function confirmSave() {
      var _this3 = this;
      this.$confirm('保存后将替换正在使用的配置，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 用户点击确定，执行保存操作
        _this3.handleSave();
      }).catch(function () {
        // 用户点击取消，不执行任何操作
        _this3.$message.info('已取消保存');
      });
    },
    // 获取图片前缀
    getImagePrefix: function () {
      var _getImagePrefix2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var response, _t4;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 1;
              return (0, _memberManagement.getImagePrefix)();
            case 1:
              response = _context6.sent;
              if (response.code === 200 && response.data) {
                this.imagePrefix = response.data;
              }
              _context6.next = 3;
              break;
            case 2:
              _context6.prev = 2;
              _t4 = _context6["catch"](0);
              console.error('获取图片前缀失败:', _t4);
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[0, 2]]);
      }));
      function getImagePrefix() {
        return _getImagePrefix2.apply(this, arguments);
      }
      return getImagePrefix;
    }(),
    // 获取图片完整URL
    getImageUrl: function getImageUrl(url) {
      // 如果没有url则返回空
      if (!url) return '';

      // 如果已经是完整URL则直接返回
      if (url.startsWith('http')) {
        return url;
      }

      // 如果有图片前缀，使用图片前缀
      if (this.imagePrefix) {
        // 确保前缀末尾没有斜杠，url开头有斜杠
        var prefix = this.imagePrefix.endsWith('/') ? this.imagePrefix.slice(0, -1) : this.imagePrefix;
        var path = url.startsWith('/') ? url : '/' + url;
        return prefix + path;
      }

      // 如果是相对路径，则加上基础URL
      return url;
    },
    triggerSelect: function triggerSelect() {
      this.$refs.fileInput.click();
    },
    handleFileChange: function () {
      var _handleFileChange = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(event) {
        var file, loading, response, _t5;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              file = event.target.files && event.target.files[0];
              if (file) {
                _context7.next = 1;
                break;
              }
              return _context7.abrupt("return");
            case 1:
              if (this.validateImage(file)) {
                _context7.next = 2;
                break;
              }
              event.target.value = '';
              return _context7.abrupt("return");
            case 2:
              // 显示上传loading
              loading = this.$loading({
                lock: true,
                text: '图片上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              }); // 调用uploadPopupImage接口上传图片
              _context7.prev = 3;
              _context7.next = 4;
              return (0, _popupConfig.uploadPopupImage)(file);
            case 4:
              response = _context7.sent;
              loading.close();
              if (response.code === 200 && response.data) {
                this.form.imageUrl = response.data;
                this.$message.success('图片上传成功');
              } else {
                this.$message.error(response.message || '图片上传失败');
              }
              _context7.next = 6;
              break;
            case 5:
              _context7.prev = 5;
              _t5 = _context7["catch"](3);
              loading.close();
              console.error('图片上传失败:', _t5);
              this.$message.error('图片上传失败: ' + (_t5.message || '未知错误'));
            case 6:
              // 允许重复选择同一文件
              event.target.value = '';
            case 7:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[3, 5]]);
      }));
      function handleFileChange(_x4) {
        return _handleFileChange.apply(this, arguments);
      }
      return handleFileChange;
    }(),
    validateImage: function validateImage(file) {
      var isImage = file.type && file.type.startsWith('image/');
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB!');
        return false;
      }
      return true;
    },
    removeImage: function removeImage() {
      var _this4 = this;
      this.$confirm('确定要移除这张图片吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this4.form.imageUrl = '';
        _this4.$message.success('图片移除成功');
      }).catch(function () {
        // 用户取消删除操作
      });
    },
    // 预览配置
    handlePreview: function () {
      var _handlePreview = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var previewData, _loading2, response, _t6;
        return regeneratorRuntime.wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              // 构造预览数据，使用新的数据结构
              previewData = {
                id: this.id,
                pageCode: this.pageKey,
                optionCode: this.moduleKey,
                extra: JSON.stringify(this.tableData) // 直接保存整个tableData数组
              }; // 显示预览loading状态
              _loading2 = this.$loading({
                lock: true,
                text: '预览中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              }); // 调用后端接口预览配置
              _context8.next = 1;
              return (0, _decorateConfig.previewDecorateConfigInfo)(previewData, this.xcxType);
            case 1:
              response = _context8.sent;
              // 关闭loading
              _loading2.close();
              if (response.code === 200) {
                // 预览成功，显示返回的图片
                if (response.data) {
                  this.previewImageUrl = response.data.image;
                  this.previewVisible = true;
                } else {
                  this.$message.success('配置预览成功');
                }
              } else {
                this.$message.error(response.message || '预览失败!');
              }
              _context8.next = 3;
              break;
            case 2:
              _context8.prev = 2;
              _t6 = _context8["catch"](0);
              // 关闭loading
              if (loading) {
                loading.close();
              }
              console.error('预览失败:', _t6);
              this.$message.error('预览失败: ' + (_t6.message || '未知错误'));
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[0, 2]]);
      }));
      function handlePreview() {
        return _handlePreview.apply(this, arguments);
      }
      return handlePreview;
    }(),
    // 处理预览弹窗关闭
    handlePreviewClose: function handlePreviewClose() {
      this.previewVisible = false;
      // 释放图片URL对象
      if (this.previewImageUrl) {
        URL.revokeObjectURL(this.previewImageUrl);
        this.previewImageUrl = '';
      }
    }
  }, "handlePreviewClose", function handlePreviewClose() {
    this.previewVisible = false;
    // 释放图片URL对象
    if (this.previewImageUrl) {
      URL.revokeObjectURL(this.previewImageUrl);
      this.previewImageUrl = '';
    }
  }), "beforeDestroy", function beforeDestroy() {
    // 释放图片URL对象
    if (this.previewImageUrl) {
      URL.revokeObjectURL(this.previewImageUrl);
      this.previewImageUrl = '';
    }
  }), "loadConfig", function () {
    var _loadConfig = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
      var _loading3, response, _t7;
      return regeneratorRuntime.wrap(function (_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;
            if (!(!this.pageKey || !this.moduleKey)) {
              _context9.next = 1;
              break;
            }
            return _context9.abrupt("return");
          case 1:
            // 显示加载loading状态
            _loading3 = this.$loading({
              lock: true,
              text: '加载配置中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            }); // 调用后端接口获取配置
            _context9.next = 2;
            return (0, _decorateConfigItem.getDecorateConfigItem)(this.pageKey, this.moduleKey, this.currentPage, this.pageSize, this.searchName);
          case 2:
            response = _context9.sent;
            // 关闭loading
            _loading3.close();
            if (response.code === 200 && response.records) {
              // 解析配置信息
              this.tableData = response.records.map(function (item) {
                try {
                  // extra字段保存的是单个对象的JSON字符串
                  var configInfo = item.extra ? JSON.parse(item.extra) : {};
                  return {
                    id: item.id,
                    title: configInfo.title || item.title || '',
                    imageUrl: configInfo.imageUrl || '',
                    redirectUrl: configInfo.redirectUrl || '',
                    recommendContentParam: configInfo.recommendContentParam || '',
                    startTime: configInfo.startTime || null,
                    endTime: configInfo.endTime || null,
                    sort: item.sort || 0,
                    enable: item.enable !== undefined ? item.enable : false // 默认启用
                  };
                } catch (e) {
                  console.error('解析配置信息失败:', e);
                  return {
                    id: item.id,
                    title: item.title || '',
                    imageUrl: '',
                    redirectUrl: '',
                    startTime: null,
                    endTime: null,
                    enable: item.enable !== undefined ? item.enable : false // 默认启用
                  };
                }
              });

              // 保存原始数据用于搜索
              this.originalTableData = (0, _toConsumableArray2.default)(this.tableData);
              this.total = response.total;
            } else if (response.code !== 200) {
              this.$message.error(response.message || '配置加载失败!');
            }
            // 如果response.data为空，说明还没有保存过配置，使用默认值
            _context9.next = 4;
            break;
          case 3:
            _context9.prev = 3;
            _t7 = _context9["catch"](0);
            // 关闭loading
            if (loading) {
              loading.close();
            }
            console.error('配置加载失败:', _t7);
            this.$message.error('配置加载失败: ' + (_t7.message || '未知错误'));
          case 4:
          case "end":
            return _context9.stop();
        }
      }, _callee9, this, [[0, 3]]);
    }));
    function loadConfig() {
      return _loadConfig.apply(this, arguments);
    }
    return loadConfig;
  }()), "handleQuery", function () {
    var _handleQuery = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee0() {
      return regeneratorRuntime.wrap(function (_context0) {
        while (1) switch (_context0.prev = _context0.next) {
          case 0:
            // 重置分页参数
            this.currentPage = 1;
            // 重新加载配置
            _context0.next = 1;
            return this.loadConfig();
          case 1:
          case "end":
            return _context0.stop();
        }
      }, _callee0, this);
    }));
    function handleQuery() {
      return _handleQuery.apply(this, arguments);
    }
    return handleQuery;
  }()), "getPageList", function () {
    var _getPageList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee1() {
      var response, _t8;
      return regeneratorRuntime.wrap(function (_context1) {
        while (1) switch (_context1.prev = _context1.next) {
          case 0:
            _context1.prev = 0;
            _context1.next = 1;
            return (0, _popupConfig.queryPageList)();
          case 1:
            response = _context1.sent;
            if (response.code === 200 && response.data) {
              this.pageList = response.data;
            } else {
              console.error('获取页面列表失败:', response.message);
            }
            _context1.next = 3;
            break;
          case 2:
            _context1.prev = 2;
            _t8 = _context1["catch"](0);
            console.error('获取页面列表错误:', _t8);
          case 3:
          case "end":
            return _context1.stop();
        }
      }, _callee1, this, [[0, 2]]);
    }));
    function getPageList() {
      return _getPageList.apply(this, arguments);
    }
    return getPageList;
  }()), "getPageName", function getPageName(pageUrl) {
    if (!pageUrl) return '';
    var page = this.pageList.find(function (item) {
      return item.pageUrl === pageUrl;
    });
    return page ? page.pageName : pageUrl;
  }), "handleSelectionChange", function handleSelectionChange(selection) {
    this.selectedItems = selection;
  }), "preview", function () {
    var _preview = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
      var loadingInstance, ids, previewData, response, _t9;
      return regeneratorRuntime.wrap(function (_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            if (!(this.selectedItems.length === 0)) {
              _context10.next = 1;
              break;
            }
            this.$message.warning('请至少选择一条数据进行预览');
            return _context10.abrupt("return");
          case 1:
            loadingInstance = null;
            _context10.prev = 2;
            // 获取选中数据的ID
            ids = this.selectedItems.map(function (item) {
              return item.id;
            }); // 构造预览参数
            previewData = {
              ids: ids,
              pageCode: this.pageKey,
              optionCode: this.moduleKey,
              xcxType: this.xcxType,
              pageURl: "" // 设置默认页面URL，可根据实际需求调整
            }; // 显示加载loading状态
            loadingInstance = this.$loading({
              lock: true,
              text: '预览生成中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });

            // 调用预览接口
            _context10.next = 3;
            return (0, _decorateConfig.previewAdd)(previewData);
          case 3:
            response = _context10.sent;
            // 关闭loading
            if (loadingInstance) {
              loadingInstance.close();
            }
            if (response.code === 200) {
              // 预览成功，显示返回的图片
              if (response.data) {
                // 检查是否有二维码URL直接返回
                if (response.data.image && typeof response.data.image === 'string') {
                  // 如果返回了二维码URL，显示预览弹窗
                  this.previewImageUrl = response.data.image;
                  this.previewVisible = true;
                } else {
                  this.$message.success('预览二维码生成成功');
                }
              } else {
                this.$message.success('预览二维码生成成功');
              }
            } else {
              this.$message.error(response.message || '预览失败!');
            }
            _context10.next = 5;
            break;
          case 4:
            _context10.prev = 4;
            _t9 = _context10["catch"](2);
            // 关闭loading
            if (loadingInstance) {
              loadingInstance.close();
            }
            console.error('预览失败:', _t9);
            this.$message.error('预览失败: ' + (_t9.message || '未知错误'));
          case 5:
          case "end":
            return _context10.stop();
        }
      }, _callee10, this, [[2, 4]]);
    }));
    function preview() {
      return _preview.apply(this, arguments);
    }
    return preview;
  }()), "handleSizeChange", function handleSizeChange(val) {
    this.pageSize = val;
    this.currentPage = 1;
    this.loadConfig();
  }), "handleCurrentChange", function handleCurrentChange(val) {
    this.currentPage = val;
    this.loadConfig();
  })
};